// @flow

import { getComponentSettings } from './main';

import { type State } from '../reducers';

type GlobalState = {
  componentSettings: State,
};

export type FAQCategoryListSettings = $PropertyType<State, 'faq_category_list'>;
export const getFAQCategoryListSettings = (state: GlobalState): FAQCategoryListSettings => {
  const FAQCategoryList = getComponentSettings(state).faq_category_list;
  if (!FAQCategoryList) {
    throw new Error('Missing faq_category_list settings in componentSettings store.');
  }
  return FAQCategoryList;
};

export const getChooseACategoryText = (state: GlobalState) => (
  getFAQCategoryListSettings(state).choose_a_category_text
);
